// import React, { useRef, useState, useCallback, useEffect } from 'react'
// import './style.css'
// import { useLocation } from 'react-router-dom';

// const TrustedPartner = ({ hideTrusted, heading, showGoogleIcons, category }) => {
//     const [startScroll, setStartScroll] = useState(false);

//     const clientLogos = [
//         { src: "/images/client-logo/google.png", alt: "Google", width: 100, category: "chatbot" },
//         { src: "/images/client-logo/azure.svg", alt: "Azure", width: 220, category: "chatbot" },
//         { src: "/images/client-logo/aws.png", alt: "AWS", width: 70, category: "chatbot" },
//         { src: "/images/client-logo/vercel.png", alt: "Vercel", width: 120, category: "homepage" },
//         { src: "/images/ecommerce-tech-stacks/intel.png", alt: "Intel", width: 160, category: "chatbot" },
//         { src: "/images/client-logo/cisco.png", alt: "Sisco", width: 100, category: "chatbot" },
//         { src: "/images/client-logo/canbrik.png", alt: "Can Brick", width: 220, category: "chatbot" },
//         { src: "/images/client-logo/KKHouston.png", alt: "KNK Huston", width: 200, category: "chatbot" },

//         { src: "/images/client-logo/Cabber.png", alt: "Cabber", width: 120, category: "customSoftware" },
//         { src: "/images/client-logo/central.png", alt: "Central", width: 90, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo1.png", alt: "Air A2b", width: 100, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo2.png", alt: "Beyond The Face", width: 130, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo6.png", alt: "FRITZ", width: 230, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo10.png", alt: "International Sailing Academy", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo11.png", alt: "Netexam", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo12.png", alt: "Prod Ticket", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo13.png", alt: "Pharma", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo14.png", alt: "Resume Yawk", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/client-logo15.png", alt: "Women Workout", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/cs-solution.png", alt: "CS Solution", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/demeterkast.avif", alt: "Demeterkast", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/Esi.png", alt: "ESI", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/every-listing.png", alt: "Every Listing", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/Immogo.png", alt: "Immogo", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/insur-quoter.png", alt: "Insur Quoter", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/myfetetickets.png", alt: "My Fete Tickets", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/qibble.png", alt: "Qibble", width: 180, category: "food" },
//         { src: "/images/client-logo/still-water.png", alt: "Still Water Capital", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/strop-drawing.png", alt: "Strop Drawing", width: 180, category: "customSoftware" },
//         { src: "/images/client-logo/swell.png", alt: "Swell", width: 160, category: "customSoftware" },
//         { src: "/images/client-logo/maud.png", alt: "Maud", width: 180, category: "customSoftware" },

//         { src: "/images/ecommerce-tech-stacks/Frame-2.svg", alt: "Magento", width: 120, category: "ecommerce" },
//         { src: "/images/ecommerce-tech-stacks/Frame.svg", alt: "Shopify", width: 120, category: "ecommerce" },
//         { src: "/images/ecommerce-tech-stacks/Frame-1.svg", alt: "woocommerce", width: 130, category: "ecommerce" },
//         { src: "/images/client-logo/dangorder.png", alt: "Dangorder", width: 180, category: "ecommerce" },
//         { src: "/images/client-logo/client-logo7.png", alt: "Hotel Items", width: 250, category: "ecommerce" },
//         { src: "/images/client-logo/abito.svg", alt: "Abito", width: 180, category: "ecommerce" },
//         { src: "/images/client-logo/amarican-moisture.svg", alt: "Amarican Moisture", width: 220, category: "ecommerce" },
//         { src: "/images/client-logo/mile-to-midnight.svg", alt: "Mile to Midnight", width: 180, category: "ecommerce" },
//         { src: "/images/client-logo/drivelab.svg", alt: "Drive Lab", width: 180, category: "ecommerce" },
//         { src: "/images/client-logo/Thinkontop.svg", alt: "Think On Top", width: 180, category: "ecommerce" },
//     ];

//     const sdkLogos = [
//         "Google",
//         "Vercel",
//         "AWS",
//         "Mirco Soft",
//         "Resume Yawk",
//         "Pharma",
//         "Netexam",
//         "Azure",
//         "Patrick",
//     ];

//     // Step 1: Filter by showGoogleIcons
//     let filteredLogos = showGoogleIcons
//         ? clientLogos
//         : clientLogos.filter(logo => !sdkLogos.includes(logo.alt));

//     // Step 2: Filter by category if provided
//     if (category) {
//         filteredLogos = filteredLogos.filter(logo => logo.category === category);
//     }

//     const location = useLocation();
//     const homePaths = ["/", "/us", "/ksa", "/au", "/uae"];
//     const isHomePage = homePaths.includes(location.pathname);

//     useEffect(() => {
//         const handleScroll = () => {
//             if (window.scrollY >= 100) {
//                 setStartScroll(true);
//             } else {
//                 setStartScroll(false);
//             }
//         };
//         window.addEventListener("scroll", handleScroll);
//         return () => window.removeEventListener("scroll", handleScroll);
//     }, []);

//     return (
//         <>
//             {!isHomePage && !hideTrusted && (
//                 <div className="grey-bg-box pt-4">
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-md-12">
//                                 <h2 className="trusted-main-heading">
//                                     {heading || "We're Trusted By:"}
//                                 </h2>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="trusted-partners-main-box">
//                 <div className="container">
//                     <div className="row mt-3">
//                         <div className="col-md-12">
//                             <div className="client-logo-slider-wrapper overflow-hidden mt-3">
//                                 <div
//                                     className={`client-logo-slider-box flex ${startScroll ? "animate-scroll" : ""}`}
//                                 >
//                                     {filteredLogos.concat(filteredLogos).map((logo, index) => (
//                                         <img
//                                             key={index}
//                                             className="trusted-logo-images"
//                                             src={logo.src}
//                                             alt={logo.alt}
//                                             width={logo.width || 100}
//                                             height={60}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default TrustedPartner;

import React, { useRef, useState, useEffect } from 'react';
import './style.css';
import { useLocation } from 'react-router-dom';

const TrustedPartner = ({ hideTrusted, heading, showGoogleIcons, category }) => {
    const [startScroll, setStartScroll] = useState(false);
    const sliderRef = useRef(null);
    const [animationDuration, setAnimationDuration] = useState("70s");

    const SCROLL_SPEED = 40; // pixels per second (adjust this to your liking)

    const clientLogos = [
        // { src: "/images/client-logo/google.png", alt: "Google", width: 120, category: "chatbot" },
        // { src: "/images/client-logo/azure.svg", alt: "Azure", width: 220, category: "chatbot" },
        // { src: "/images/client-logo/aws.png", alt: "AWS", width: 70, category: "chatbot" },
        // { src: "/images/ecommerce-tech-stacks/intel.png", alt: "Intel", width: 160, category: "chatbot" },
        // { src: "/images/client-logo/cisco.png", alt: "Sisco", width: 100, category: "chatbot" },

        { src: "/images/client-logo/google-developers.png", alt: "Google Developers", width: 150, category: "chatbot" },
        { src: "/images/client-logo/amazon-web-services.png", alt: "AMAZON WEB SERVICES", width: 100, category: "chatbot" },
        { src: "/images/client-logo/google-cloude-sdk.png", alt: "Google", width: 100, category: "chatbot" },
        { src: "/images/client-logo/intel-ai-sdk.png", alt: "Intel", width: 100, category: "chatbot" },
        { src: "/images/client-logo/google-cloud-sdk.png", alt: "Google Cloude", width: 100, category: "chatbot" },
        { src: "/images/client-logo/aws-sdk.png", alt: "AWS", width: 90, category: "chatbot" },
        { src: "/images/client-logo/azuer-sdk.png", alt: "Azure", width: 100, category: "chatbot" },
        { src: "/images/client-logo/intel-sdk.png", alt: "Intel Tiber", width: 100, category: "chatbot" },
        { src: "/images/client-logo/one-api.png", alt: "One API", width: 100, category: "chatbot" },
        { src: "/images/client-logo/cloude-azure.png", alt: "Azure Cloude", width: 100, category: "chatbot" },
        { src: "/images/client-logo/cisco-sdk.png", alt: "Cisco", width: 100, category: "chatbot" },
        { src: "/images/client-logo/kanbrick.png", alt: "Can Brick", width: 180, category: "chatbot" },
        { src: "/images/client-logo/KKHouston.png", alt: "KNK Huston", width: 170, category: "chatbot" },

        { src: "/images/client-logo/vercel.png", alt: "Vercel", width: 100, category: "homepage" },
        { src: "/images/client-logo/Cabber.png", alt: "Cabber", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/central.png", alt: "Central", width: 90, category: "customSoftware" },
        { src: "/images/client-logo/client-logo1.png", alt: "Air A2b", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/client-logo2.png", alt: "Beyond The Face", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/client-logo6.png", alt: "FRITZ", width: 230, category: "customSoftware" },
        { src: "/images/client-logo/client-logo10.png", alt: "International Sailing Academy", width: 180, category: "customSoftware" },
        { src: "/images/client-logo/client-logo11.png", alt: "Netexam", width: 180, category: "customSoftware" },
        { src: "/images/client-logo/client-logo12.png", alt: "Prod Ticket", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/client-logo13.png", alt: "Pharma", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/client-logo14.png", alt: "Resume Yawk", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/client-logo15.png", alt: "Women Workout", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/cs-solution.png", alt: "CS Solution", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/demeterkast.png", alt: "Demeterkast", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/Esi.png", alt: "ESI", width: 80, category: "customSoftware" },
        { src: "/images/client-logo/every-listing.png", alt: "Every Listing", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/Immogo.png", alt: "Immogo", width: 130, category: "customSoftware" },
        { src: "/images/client-logo/insur-quoter.png", alt: "Insur Quoter", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/myfetetickets.png", alt: "My Fete Tickets", width: 150, category: "customSoftware" },
        { src: "/images/client-logo/qibble.png", alt: "Qibble", width: 120, category: "food" },
        { src: "/images/client-logo/still-water.png", alt: "Still Water Capital", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/strop-drawing.png", alt: "Strop Drawing", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/swell.png", alt: "Swell", width: 120, category: "customSoftware" },
        { src: "/images/client-logo/maud.png", alt: "Maud", width: 130, category: "customSoftware" },

        { src: "/images/ecommerce-tech-stacks/Frame-2.svg", alt: "Magento", width: 120, category: "ecommerce" },
        { src: "/images/ecommerce-tech-stacks/Frame.svg", alt: "Shopify", width: 120, category: "ecommerce" },
        { src: "/images/ecommerce-tech-stacks/Frame-1.svg", alt: "woocommerce", width: 120, category: "ecommerce" },
        { src: "/images/client-logo/dangorder.png", alt: "Dangorder", width: 150, category: "ecommerce" },
        { src: "/images/client-logo/client-logo7.png", alt: "Hotel Items", width: 150, category: "ecommerce" },
        { src: "/images/client-logo/abito.svg", alt: "Abito", width: 70, category: "ecommerce" },
        { src: "/images/client-logo/amarican-moisture.svg", alt: "Amarican Moisture", width: 100, category: "ecommerce" },
        { src: "/images/client-logo/mile-to-midnight.svg", alt: "Mile to Midnight", width: 150, category: "ecommerce" },
        { src: "/images/client-logo/drivelab.svg", alt: "Drive Lab", width: 100, category: "ecommerce" },
        { src: "/images/client-logo/Thinkontop.svg", alt: "Think On Top", width: 150, category: "ecommerce" },


        { src: "/images/client-logo/eclinicalworks.png", alt: "eclinicalworks", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/ocean.png", alt: "ocean", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/veradigm.png", alt: "veradigm", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/allscript.png", alt: "all script", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/nextgen.png", alt: "next gen", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/athenahealtch.png", alt: "athenahealth", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/openemr.png", alt: "open EMR", width: 150, category: "auraclinic" },
    ];

    const sdkLogos = ["Google", "Vercel", "AWS", "Mirco Soft", "Resume Yawk", "Pharma", "Netexam", "Azure", "Patrick"];

    let filteredLogos = showGoogleIcons
        ? clientLogos
        : clientLogos.filter(logo => !sdkLogos.includes(logo.alt));

    if (category) {
        filteredLogos = filteredLogos.filter(logo => logo.category === category);
    }

    const location = useLocation();
    const homePaths = ["/", "/us", "/ksa", "/au", "/uae"];
    const isHomePage = homePaths.includes(location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            setStartScroll(window.scrollY >= 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ✅ Dynamically calculate animation duration
    useEffect(() => {
        if (sliderRef.current) {
            const totalWidth = sliderRef.current.scrollWidth / 2; // half because you duplicate logos
            const duration = totalWidth / SCROLL_SPEED; // seconds
            setAnimationDuration(`${duration}s`);
        }
    }, [filteredLogos]);

    return (
        <>
            {!isHomePage && !hideTrusted && (
                <div className="grey-bg-box pt-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="trusted-main-heading">
                                    {heading || "We're Trusted By:"}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="trusted-partners-main-box">
                <div className="container">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="client-logo-slider-wrapper overflow-hidden mt-3">
                                <div
                                    ref={sliderRef}
                                    className={`client-logo-slider-box flex ${startScroll ? "animate-scroll" : ""}`}
                                    style={{
                                        animationDuration: animationDuration,
                                    }}
                                >
                                    {filteredLogos.concat(filteredLogos).map((logo, index) => (
                                        <img
                                            key={index}
                                            className="trusted-logo-images"
                                            src={logo.src}
                                            alt={logo.alt}
                                            width={logo.width || 100}
                                            height={60}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TrustedPartner;